// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aeonikAir_463bdb', '__aeonikAir_Fallback_463bdb'"},"className":"__className_463bdb","variable":"__variable_463bdb"};